
import { FETCH_LIST_SUCCESS, FETCH_LIST_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  lastSubData: [],
  error: null,
  redirectToLoginPage: false,
};

const listReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_SUCCESS:
      return {
        ...state,
        lastSubData: action.payload.lastSubData,
        error: null,
      };
    case FETCH_LIST_FAILURE:
      return {
        ...state,
        lastSubData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default listReducer;
